import graphqlHelperService from "./graphqlHelper.service";
import { Address } from "../types/register";

export const zipCodeAPIService = {
    getAddress: async (houseNumber: string, zipCode: string): Promise<Address> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            zipCodeAPIQuery,
            { houseNumber, zipCode }
        );
        return apolloResult.getAddress as Address;
    },
};

const zipCodeAPIQuery = `query GetAddress($houseNumber: String!, $zipCode: String!) {
    getAddress(houseNumber: $houseNumber, zipCode: $zipCode) {
        address
        place
    }
}`